module.exports = "/assets/data/fd23674f5498c2739585b151ec649a82-NR5.data.json";